export enum GcashDocumentStatuses {
  PROCESSING = 'PROCESSING',
  APPROVED = 'APPROVED',
  NEEDS_REVIEW = 'NEEDS_REVIEW',
  REJECTED = 'REJECTED',
  FAILED = 'FAILED',
  QUARANTINED = 'QUARANTINED',
  QUALITY_CHECK_FAILED = 'QUALITY_CHECK_FAILED',
  PROCESSING_FAILED = 'PROCESSING_FAILED',
  QUALITY_REJECTED = 'QUALITY_REJECTED',
  EXTRACTION_FAILED = 'EXTRACTION_FAILED',
  EXTRACTION_NEEDS_REVIEW = 'EXTRACTION_NEEDS_REVIEW',
  ANALYSIS_FAILED = 'ANALYSIS_FAILED',
  ANALYSIS_NEEDS_REVIEW = 'ANALYSIS_NEEDS_REVIEW',
  ANALYSIS_APPROVED = 'ANALYSIS_APPROVED',
}
